import { useState } from "react";
import { useSnackbar } from "notistack";

import { Button, Stack, Switch, TextField } from "@mui/material";

import { api } from "../../../../../utils";
import { IError } from "../../../../../models/ReportPageModels";

interface CreateAdminUserRequest {
    username: string;
    password: string;
    alitSystems: boolean;
    iccGeneral: boolean;
    mobile: boolean;
    billing: boolean;
    xero: boolean;
    other: boolean;
}
interface CreateAdminUserResponse {
    data: CreateAdminUserData;
    error: IError;
}
interface CreateAdminUserData {
    status: string;
}

function CreateAdminUser() {
    const { enqueueSnackbar } = useSnackbar();

    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const [alitSystems, setAlitSystems] = useState<boolean>(false);
    const [iccGeneral, setIccGeneral] = useState<boolean>(false);
    const [mobile, setMobile] = useState<boolean>(false);
    const [billing, setBilling] = useState<boolean>(false);
    const [xero, setXero] = useState<boolean>(false);
    const [other, setOther] = useState<boolean>(false);

    const CreateClient = async () => {
        if (username === "" || password === "" ||
            (!alitSystems && !iccGeneral && !mobile && !billing && !xero && !other)) {
            enqueueSnackbar("Please recheck fields", { variant: "error" });
            return;
        }

        var body: CreateAdminUserRequest = {
            username: username,
            password: password,
            alitSystems: alitSystems,
            iccGeneral: iccGeneral,
            mobile: mobile,
            billing: billing,
            xero: xero,
            other: other
        }

        try {
            const response: CreateAdminUserResponse = await api.post("api/Admin/CreateAdminUser", {
                json: body,
                headers: {
                    "Authorization": localStorage.getItem("token")!
                }
            }).json();

            if (response.error == null) {
                enqueueSnackbar("Created!", { variant: "success" })
                // clear fields
                setUsername("");
                setPassword("");
                setAlitSystems(false);
                setIccGeneral(false);
                setMobile(false);
                setBilling(false);
                setXero(false);
                setOther(false);
            }
            else {
                enqueueSnackbar(response.error.description, { variant: "error" });
            }
        }
        catch (err) {
            enqueueSnackbar((err as Error).message, { variant: "error" });
        }
    }

    return (
        <Stack>
            {/* Username */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>Username: </p>
                <TextField
                    value={username}
                    onChange={(newValue: any) => { setUsername(newValue.target.value) }}
                    sx={{ minWidth: 245 }}
                    size="small" />
            </Stack>
            {/* Password */}
            <Stack
                direction={"row"}
                alignItems={"center"}>
                <p style={{ width: '110px' }}>Password: </p>
                <TextField
                    value={password}
                    onChange={(newValue: any) => { setPassword(newValue.target.value) }}
                    sx={{ minWidth: 245 }}
                    size="small" />
            </Stack>
            {/* ALIT systems */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>ALIT Systems: </p>
                <Switch
                    checked={alitSystems}
                    onChange={(newValue) => { setAlitSystems(newValue.target.checked) }}
                    size="small" />
            </Stack>
            {/* ICC General */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>ICC General: </p>
                <Switch
                    checked={iccGeneral}
                    onChange={(newValue) => { setIccGeneral(newValue.target.checked) }}
                    size="small" />
            </Stack>
            {/* Moobile */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>Mobile: </p>
                <Switch
                    checked={mobile}
                    onChange={(newValue) => { setMobile(newValue.target.checked) }}
                    size="small" />
            </Stack>
            {/* Billing */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>Billing: </p>
                <Switch
                    checked={billing}
                    onChange={(newValue) => { setBilling(newValue.target.checked) }}
                    size="small" />
            </Stack>
            {/* Xero */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>Xero: </p>
                <Switch
                    checked={xero}
                    onChange={(newValue) => { setXero(newValue.target.checked) }}
                    size="small" />
            </Stack>
            {/* Other */}
            <Stack
                direction={"row"}
                alignItems={"center"} >
                <p style={{ width: '110px' }}>Other: </p>
                <Switch
                    checked={other}
                    onChange={(newValue) => { setOther(newValue.target.checked) }}
                    size="small" />
            </Stack>

            <Button
                variant="outlined"
                onClick={() => CreateClient()}
                sx={{ width: '82px' }}>
                Create
            </Button>
        </Stack>
    )
}

export default CreateAdminUser;